import React from "react";
import Nav from "../../components/Navbar/Nav";
import Banner from "../../components/Banner/Banner";
import requests from "../../api/Requests";
import Row from "../../components/Movies/Row";

function Movies() {
	return (
		<div className="homeScreen">
			<Nav />
			<Banner fetchUrl={requests.fetchNetflixOriginals} />
			<div className="row-container">
				<Row title="Now Playing" fetchUrl={requests.fetchNowPlaying} isLargeRow />
				<Row title="Popular Movies" fetchUrl={requests.fetchPopularMovies} isLargeRow />
				<Row title="Top Rated" fetchUrl={requests.fetchTopRated} isLargeRow />
				<Row title="Upcoming" fetchUrl={requests.fetchUpcoming} isLargeRow />
				<Row title="Action" fetchUrl={requests.fetchActionMovies} isLargeRow />
				<Row title="Adventure" fetchUrl={requests.fetchAdventureMovies} isLargeRow />
				<Row title="Comedy" fetchUrl={requests.fetchComedyMovies} isLargeRow />
				<Row title="Drama" fetchUrl={requests.fetchDramaMovies} isLargeRow />
				<Row title="Horror" fetchUrl={requests.fetchHorrorMovies} isLargeRow />
				<Row title="Sci-Fi" fetchUrl={requests.fetchSciFiMovies} isLargeRow />
				<Row title="Thriller" fetchUrl={requests.fetchThrillerMovies} isLargeRow />
				<Row title="Animation" fetchUrl={requests.fetchAnimationMovies} isLargeRow />
				<Row title="Crime" fetchUrl={requests.fetchCrimeMovies} isLargeRow />
				<Row title="Documentary" fetchUrl={requests.fetchDocumentaryMovies} isLargeRow />
				<Row title="Romance" fetchUrl={requests.fetchRomanceMovies} isLargeRow />
				<Row title="War" fetchUrl={requests.fetchWarMovies} isLargeRow />
			</div>
		</div>
	);
}

export default Movies;
